// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"22412787","732":"6439d98c"}[chunkId] + ".chunk.js";
};